import { computed } from 'vue';
import { useStore } from 'vuex';
import { template, templateSettings } from 'lodash';
import { LABEL_MAP, MESSAGE_MAP } from '@/config/message';

templateSettings.interpolate = /{{([\s\S]+?)}}/g;

export const useError = () => {
  const store = useStore();

  const errorFields = computed(() => store.getters['common/errorFields']);

  const getErrors = (validators) => {
    let errors = [];
    validators.$errors.forEach((v) => {
      const rule = v.$validator;
      const compiled = template(MESSAGE_MAP[rule]);
      const noLabelFirst = v.$params?.noLabelFirst;
      errors.push(`${noLabelFirst ? '' : LABEL_MAP[v.$property]}${compiled(v.$params)}`);
    });
    store.dispatch('common/setErrors', errors);
    store.dispatch('common/openErrorModal', true);
  };

  const isInputError = (validators, keyInput) => {
    if (errorFields.value[keyInput]) return errorFields.value[keyInput];
    if (validators && keyInput && validators[keyInput]) return validators[keyInput].$error;
    return false;
  };

  const getErrorsWithEventStatus = (statusList) => {
    const status = store.getters['event/childEventInfo']?.status?.id;
    const errorStatus = statusList.find(item => item.value === status);
    if (status && errorStatus) {
      const compiled = template(MESSAGE_MAP.statusEvent);
      const error = compiled({
        status: statusList.map(item => item.label).join('又は')
      });
      store.dispatch('common/setErrors', [error]);
      store.dispatch('common/openErrorModal', true);
      store.dispatch('common/setModalBackToRoute', 'Home');
    }
  };

  return {
    errorFields,
    getErrors,
    isInputError,
    getErrorsWithEventStatus,
  };
};
